import { ExtendedConector, WalletBalances } from "#/shared/types"

export const filterWalletBalances = (
  balances: WalletBalances,
  isBitcoinFlow: boolean,
) => {
  const filteredBalances: Partial<WalletBalances> = {}

  Object.entries(balances).forEach(([token, { balance, decimals }]) => {
    if (isBitcoinFlow && token === "BTC") {
      filteredBalances[token] = { balance, decimals }
    }

    if (!isBitcoinFlow && (token === "tBTC" || token === "WBTC")) {
      filteredBalances[token] = { balance, decimals }
    }
  })

  return filteredBalances
}

export const getConnectorIcon = (connector: ExtendedConector) =>
  connector.icon ?? connector.rkDetails.iconUrl
